<template>
  <div class="page">
    <div class="nav">
      <span
        :class="selected == '月分析' ? 'selected' : ''"
        @click="toggle('月分析')"
        >月分析</span
      >
      <span>|</span>
      <span
        :class="selected == '明细' ? 'selected' : ''"
        @click="toggle('明细')"
        >明细</span
      >
    </div>

    <in-month v-if="selected == '月分析'" @toggle="toggle" />
    <sale-in v-if="selected == '明细'" :condition="condition" />
  </div>
</template>

<script>
import InMonth from "@/components/InMonth/InMonth.vue";
import SaleIn from "@/components/InMonth/SaleIn.vue";

export default {
  components: {
    InMonth,
    SaleIn,
  },

  data() {
    return {
      selected: "月分析",
      condition: null,
    };
  },
  methods: {
    toggle(val, data) {
      this.selected = val;

      if (val == "明细" && data) {
        this.condition = data;
      } else {
        this.condition = null;
      }
    },
  },
};
</script>

<style scoped>
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected {
  color: #38559f;
}
@media screen and (min-width: 500px) {
  .nav {
    display: none;
  }
}
</style>